<template>
  <div class="box box-success">
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-labeled btn-primary pull-right"
              @click="onAddNew"
              style="margin-right: 5px;"
            >
              <span class="btn-label"> <i class="fa fa-plus"></i> </span>
              {{ $t("common.addnew") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top: 15px">
        <b-table
          striped
          hover
          :items="productGroupItems"
          :fields="productGroupFields"
        >
          <template #head()="scope">
            <div class="">{{ $t(scope.label) }}</div>
          </template>
          <template #cell(imgUrl)="row">
            <img
              class="asset-img-class img-responsive"
              :src="row.item.imgUrl"
              alt=""
              @click="onViewImgNewTab(row.item.imgUrl)"
            />
          </template>
          <template #cell(actions)="row">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-danger dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <i class="fa fa-fw fa-ellipsis-h"></i>
              </button>
              <ul class="dropdown-menu" style="min-width: 50px">
                <li>
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment')
                    "
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditInput(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </li>
                <li style="margin-top: 5px">
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('delete_apartment')
                    "
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenDelete(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </b-table>
        <div class="box-footer clearfix" style="display:contents;">
          <custom-paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onCustomPagination"
          />
        </div>
      </div>
    </div>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <product-group-detail ref="productGroupDetail" @callbackGetProductGroup="callbackGetProductGroup"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import ProductGroupDetail from "./ProductGroupDetail.vue";
import CustomPaginator from "@/components/CustomPaginator.vue";

import utils from "@/lib/utils";
export default {
  components: {
    "lte-modal": LTEModal,
    ProductGroupDetail,
    CustomPaginator
  },
  data: () => ({
    productGroupFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "productGroupName",
        label: "product.productGroupList.productGroupName"
      },
      {
        key: "description",
        label: "product.productGroupList.description"
      },
      { key: "actions", label: "common.action" }
    ],
    productGroupItems: [],
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    }
  }),
  watch: {
    GET_PRODUCT_GROUP_LIST_DATA: function() {
      let paginate = this.GET_PRODUCT_GROUP_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_PRODUCT_GROUP_LIST_DATA.results;
      this.productGroupItems = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          productGroupName: value.name,
          description: value.description
        };
        this.productGroupItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_PRODUCT_GROUP_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onAddNew: function() {
      this.$refs.productGroupDetail.onShowAddNew();
    },
    onOpenEditInput: function(data) {
      this.$refs.productGroupDetail.onShowDetail(data);
    },
    onViewImgNewTab: function(data) {
      window.open(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_PRODUCT_GROUP(this.originalRecordData)
        .then(
          function() {
            this.callbackGetProductGroup();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getProductGroup: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_PRODUCT_GROUP_LIST(filter);
    },
    onCallbackData: function() {
      this.getProductGroup(1);
    },
    callbackGetProductGroup: function(){
      this.getProductGroup(this.paginateData.currentPage);
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data
      this.getProductGroup(data)
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_PRODUCT_GROUP_LIST",
      "DELETE_PRODUCT_GROUP"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/ProductGroupList.vue